import { ButtonProps } from '@design-system/button';
import { navigate } from 'gatsby';

import { iconMapper } from '~/mappers/common';

import { Button, ButtonWithLink } from './models';

export const buttonMapper = ({
  iconPrefix,
  iconSuffix,
  text,
  disabled,
  size,
  variant,
  ariaLabel,
}: Button): ButtonProps =>
  ({
    ...(iconPrefix?.length && {
      iconPrefix: { props: iconMapper(iconPrefix[0]) },
    }),
    ...(iconSuffix?.length && {
      iconSuffix: { props: iconMapper(iconSuffix[0]) },
    }),
    children: text,
    ...(disabled && { disabled }),
    ...(size && { size }),
    ...(variant && { variant }),
    ...(ariaLabel && { 'aria-label': ariaLabel }),
  } as ButtonProps);

export const buttonWithLinkMapper = ({
  link: { href },
  ...rest
}: ButtonWithLink) => ({
  ...buttonMapper(rest),
  link: href,
  onClick: () => navigate(href),
});
